import { useField, useFormikContext } from 'formik';
import React from 'react';

import styled from '@emotion/styled';

import ActiveRadioButtonCircle from '../Icons/ActiveRadioButtonCircle';
import InActiveRadioButtonCircle from '../Icons/InActiveRadioButtonCircle';
import { FieldErrorInfo } from './FormField';

interface CustomRadioGroupProps {
  children: React.ReactNode;
  name: string;
  className?: string;
  onValueChange?: (value: string, fieldName?: string) => void;
}

export const BundleRadioFieldGroup: React.FC<CustomRadioGroupProps> = ({
  children,
  name,
  className,
  onValueChange,
}) => {
  const { errors, touched } = useFormikContext<any>();

  return (
    <RadioGroup>
      {React.Children.map(children, (child: any) => {
        return React.cloneElement(child, {
          ...child.props,
          onValueChange,
        });
        // }
      })}

      {errors[name] && touched[name] ? (
        <CustomFieldErrorInfo className={className}>
          {(errors as any)[name].capitalize()}
        </CustomFieldErrorInfo>
      ) : null}
    </RadioGroup>
  );
};

export interface BundleRadioFieldProps {
  label?: any;
  id?: string;
  name: string;
  children?: any;
  className?: string;
  value?: string;
  isRecommended?: boolean;
  onValueChange?: (value: string, fieldName?: string) => void;
}

export const BundleRadioField: React.FC<BundleRadioFieldProps> = ({
  children,
  className,
  isRecommended,
  onValueChange,
  ...props
}) => {
  const [field] = useField({ ...props, type: 'radio' });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange(event);
    onValueChange?.(event.target.value, props.name);
  };

  return (
    <RadioWrapper className={className}>
      <label>
        <input type='radio' {...field} {...props} onChange={handleChange} />
        <RadioItemDiv>
          {children}
          {isRecommended && <Recommended>Recommended</Recommended>}
          <RadioItemActiveIcon className='active'>
            <ActiveRadioButtonCircle />
          </RadioItemActiveIcon>
          <RadioItemInactiveIcon className='inactive'>
            <InActiveRadioButtonCircle />
          </RadioItemInactiveIcon>
        </RadioItemDiv>
      </label>
    </RadioWrapper>
  );
};

const RadioItemDiv = styled.div`
  display: flex;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 16px;
  width: 100%;
  border-radius: 8px;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  /* height: 59px; */
  /* border: 1px solid red; */
`;

const RadioItemActiveIcon = styled.div`
  display: none;
`;

const RadioItemInactiveIcon = styled.div``;

const RadioWrapper = styled.div`
  & > label {
    width: 100%;
    display: grid;

    & > * {
      grid-column: 1;
      grid-row: 1;
    }
  }

  & > label input[type='radio'] {
    visibility: hidden;
  }

  & > label input[type='radio']:checked ~ div {
    font-weight: 700;
    /* color: ${({ theme }) => theme.palette.blueColor}; */
  }

  & > label input[type='radio']:checked ~ div > .active {
    display: block;
  }

  & > label input[type='radio']:checked ~ div > .inactive {
    display: none;
  }

  & > label input[type='radio']:checked ~ div {
    border: 1px solid ${({ theme }) => theme.palette.blueColor};
    background-color: #f9fbfd;
  }

  & > * {
    cursor: pointer;
  }
`;

const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  & > * {
  }
`;

const CustomFieldErrorInfo = styled(FieldErrorInfo)``;

const Recommended = styled.div`
  /* border: 1px solid red; */
  margin-top: -16px;
  align-self: flex-start;

  font-weight: 600;
  font-size: 10px;
  line-height: 10px;
  margin-right: -20px;
  margin-left: auto;
  /* text-align: center; */
  padding: 3px 8px;
  background-color: #5b91f5;
  color: white;

  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
`;
